import '../resources/css/login.scss';
import LoginApp from './App.vue';
import store from './store';
import 'login.scss';
import { listenOnMaintenanceLock } from 'c/MaintenanceLockController';

if (serverProfile.channelId) {
  sessionStorage.setItem('channelId', serverProfile.channelId);
}

(function (l) {
  // client-side redirect http to https
  if (serverProfile.environment !== 'dev' && !/https:/i.test(l.protocol)) {
    l.replace(l.href.replace(/^http:/, 'https:'));
  }
})(window.location);

listenOnMaintenanceLock().then(() => {
  window.location = `/503?redirectUrl=${encodeURIComponent(
    window.location.href
  )}`;
});

new LoginApp({
  delimiters: ['${', '}'],
  el: '#vue-channel-login',
  store,
});
